declare const window: any;

const generateCustomerNumber = async() =>{
    await window.abcWorkerPromise;
    const response = await window.Abc.core.util.generateCustomerNumber();
    return response;
}

const abcService = {
    generateCustomerNumber,
}
export default abcService;
